/** Query flag: uživatel přišel z Přehledu v Můj kabinet. */
export const CABINET_FROM_PARAM = 'from'
export const CABINET_FROM_VALUE = 'cabinet'
export const CABINET_PATH = '/my-cabinet'

/** Přidá from=cabinet k cestě (zachová existující query). */
export function withCabinetReturn(path: string): string {
  const hashIdx = path.indexOf('#')
  const hash = hashIdx >= 0 ? path.slice(hashIdx) : ''
  const withoutHash = hashIdx >= 0 ? path.slice(0, hashIdx) : path
  const qIdx = withoutHash.indexOf('?')
  const base = qIdx >= 0 ? withoutHash.slice(0, qIdx) : withoutHash
  const query = qIdx >= 0 ? withoutHash.slice(qIdx + 1) : ''
  const params = new URLSearchParams(query)
  params.set(CABINET_FROM_PARAM, CABINET_FROM_VALUE)
  const qs = params.toString()
  return `${base}?${qs}${hash}`
}

export function hasCabinetReturnFlag(search: string): boolean {
  const q = search.startsWith('?') ? search.slice(1) : search
  return new URLSearchParams(q).get(CABINET_FROM_PARAM) === CABINET_FROM_VALUE
}
